module.exports = __webpack_public_path__ + "assets/img/img2.03b91314.png";